import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Table } from 'primeng/table';
import { ConversaoLibraConverte } from '../../../shared/conversao-libra/conversao-libra-converte';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { FiltroDealers } from './filtro-dealer';
import { RelatorioCargaGwmFiltroService } from './relatorio-carga-gwm-filtro.service';
import { RelatorioCargaGwmService } from './relatorio-carga-gwm.service';

declare var $: any;

@Component({
  selector: 'app-relatorio-carga-gwm',
  templateUrl: './relatorio-carga-gwm.component.html',
  styleUrls: ['./relatorio-carga-gwm.component.scss']
})
export class RelatorioCargaGwmComponent implements OnInit {
  @Input() filtros: any;

  form: FormGroup;
  subscription: any;
  selecionado: object;
  selecionados = [];
  cols: any[];
  _selectedColumns: any[];
  dealersDados: any[] = [];
  numero_nfe: any;
  serie: any;
  id_dealer: any;
  first = 0;
  displayRows: number = 0;
  rows = 20;
  totalRecords = 0;
  loading: boolean = false;
  displayFiltros: boolean = false;
  displayFiltrosDealers: boolean = false;
  nomeModulo: string;
  dataInicial: Date;
  dataFinal: Date;
  maxDate: Date = new Date();
  filtrosDealers: FiltroDealers;
  display: boolean = false;
  cargaTela: boolean;
  tipoDescricao = [];
  processado = [];

  @ViewChild('dt') dt: Table;

  dadosTranslate = {
    "Dealer Code": "satisfacao.relatorioCargaGWM.codDealer",
    "Dealer Name": "satisfacao.relatorioCargaGWM.nomeDealer",
    "Nome Arquivo": "satisfacao.relatorioCargaGWM.nomeArquivo",
    "Tipo": "satisfacao.relatorioCargaGWM.tipoDescricao",
    "Data Proc.": "satisfacao.relatorioCargaGWM.dtProc",
    "Status": "satisfacao.relatorioCargaGWM.processado"
  }

  constructor(private service: RelatorioCargaGwmService,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private servico: RelatorioCargaGwmFiltroService,
    private exportExcelService: ExportExcelService,
    private fb: FormBuilder) {
    this.filtros = {};
    this.nomeModulo = 'relatorio-carga-gwm';
    this.filtrosDealers = new FiltroDealers(this.servico);
    this.tratarData();

    this.form = this.fb.group({
      data_inicial: [moment(this.dataInicial).format('DD-MM-YYYY')],
      data_final: [moment(this.dataFinal).format('DD-MM-YYYY')],
      dealers: [''],
      nomeArquivo: [''],
      tipoDescricao: [''],
      processado: ['']
    });

    this.maxDate.setDate(this.maxDate.getDate());
  }

  ngOnInit() {
    this.cargaTela = true;
    this.changeLanguageValue();
    this.preencherTipoDescricao();
    this.preencherProcessado();

    this.cols = [
      { field: "codDealer", header: "satisfacao.relatorioCargaGWM.codDealer", headerBr: "Dealer", headerGb: "Dealer" },
      { field: "nomeDealer", header: "satisfacao.relatorioCargaGWM.nomeDealer", headerBr: "Dealer Name", headerGb: "Dealer Name" },
      { field: "nomeArquivo", header: "satisfacao.relatorioCargaGWM.nomeArquivo", headerBr: "Nome Arquivo", headerGb: "Nome Arquivo" },
      { field: "tipoDescricao", header: "satisfacao.relatorioCargaGWM.tipoDescricao", headerBr: "Tipo", headerGb: "Type" },
      { field: "dtFimProcString", header: "satisfacao.relatorioCargaGWM.dtFimProc", headerBr: "Data Inc.", headerGb: "Data Inc." },
      { field: "dtProcString", header: "satisfacao.relatorioCargaGWM.dtProc", headerBr: "Data Proc.", headerGb: "Data Proc." },
      { field: "processado", header: "satisfacao.relatorioCargaGWM.processado", headerBr: "Status", headerGb: "Status" },
      { field: "statusProc", header: "satisfacao.relatorioCargaGWM.statusProc", headerBr: "Status Proc.", headerGb: "Status Proc." },
    ];

    this._selectedColumns = this.cols;

    this.filtrosDealers.carregar();
    this.getAll();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  get f() { return this.form.controls; }

  private preencherTipoDescricao() {
    this.tipoDescricao = [
      { nome: 'Peças', valor: "1" },
      { nome: 'Veículos', valor: "2" },
      { nome: 'Serviço', valor: "3" },
      { nome: 'Revisão', valor: "4" },
      { nome: 'Recall', valor: "5" },
      { nome: 'Recall Pendente', valor: "6" },
      { nome: 'Recall Realizado', valor: "7" },
      { nome: 'Cores do Veículo', valor: "8" },
      { nome: 'Acabamento do Veículo', valor: "9" },
      { nome: 'Chassi Aluguel', valor: "10" },
      { nome: 'Chassi Tranquilidade / Revisão Gratuita', valor: "11" }
    ];
  }

  private preencherProcessado() {
    this.processado = [
      { nome: 'Processado', valor: "true" },
      { nome: 'Pendente', valor: "false" }
    ];
  }

  private getAll() {
    this.loading = true;

    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value,
      this.f.nomeArquivo.value, this.f.tipoDescricao.value, this.f.processado.value).subscribe(dados => {
        this.dealersDados = dados.dealers;
        this.orderByDate();

        this.dealersDados.forEach(element => {
          const atual = this.conversaoLibraConverte.conversaoLibra(element.valorVendaItem, null, null);
          const valorFormatado = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(atual);
          element.valorVendaItem = valorFormatado.replace("R$", "");
          // element.dataAbertura = element.dataAbertura.substring(0, 10);
          // element.dataFechamento = element.dataFechamento.substring(0, 10);
        });

        this.loading = false;
        this.cargaTela = false;
      });
  }

  private orderByDate() {
    this.dealersDados.sort((a, b) => {
      let data_a = a.data;
      let data_b = b.data;

      if (data_a > data_b) return -1;
      if (data_a < data_b) return 1;

      return 0;
    });
  }

  private tratarData() {
    const dataInicio = new Date();
    const dataFim = new Date();

    let firstDay = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);

    this.dataInicial = firstDay;
    this.dataFinal = dataFim;
  }

  public filtroAPI() {
    this.displayFiltros = false;

    this.f.data_inicial.setValue(moment(this.dataInicial).format('DD-MM-YYYY'));
    this.f.data_final.setValue(moment(this.dataFinal).format('DD-MM-YYYY'));

    this.filtrosSelecionados();
    this.getAll();
  }

  private filtrosSelecionados() {
    const dealers = [];

    this.incluirFiltroDealers(dealers);

    this.filtros.dealers = dealers.map(r => r.valor);

    if (this.filtros.dealers.length != 0) {
      this.f.dealers.setValue(this.filtros.dealers[0]);
    } else {
      this.f.dealers.setValue('');
    }
  }

  public getListagemComFiltros(): boolean {
    return this.dataInicial
      || this.dataFinal
      || this.f.nomeArquivo.value
      || this.f.tipoDescricao.value
      || this.f.processado.value
  }

  public selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  public removerDealer(dealer: any) {
    dealer.selecionado = false;
    const index = this.filtros.dealers;
    if (index > -1) {
      this.filtros.dealers.splice(index, dealer);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarDealerFiltro(dealer: any) {
    dealer.selecionado = true;
    const sel = [];

    this.incluirFiltroDealers(sel);
    this.filtros.dealers = sel;
  }

  public exibirFiltro() {
    this.displayFiltros = true;
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtrosDealers.selecionados().length > 0) {
      const item = { 'chave': 'dealers', 'valor': [] };
      this.filtrosDealers.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  public limparFiltros() {
    this.f.nomeArquivo.setValue('');
    this.f.tipoDescricao.setValue('');
    this.f.processado.setValue('');
  }

  public limpaDataInicial() {
    const dataInicio = new Date();
    this.dataInicial = new Date(dataInicio.getUTCFullYear(), dataInicio.getMonth(), 1);
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.dataFinal = new Date(dataFim.getFullYear(), dataFim.getMonth(), dataFim.getDate());
  }

  protected getTranslate(value) {

    return this.dadosTranslate[value];
  }

  private translateHeader(item) {
    if (item == "satisfacao.relatorioCargaGWM.codDealer") {
      return this.translate.currentLang == "br" ? "Cód. Dealer" : "Dealer Code";
    }
    if (item == "satisfacao.relatorioCargaGWM.nomeDealer") {
      return this.translate.currentLang == "br" ? "Nome Dealer" : "Dealer Name";
    }
    if (item == "satisfacao.relatorioCargaGWM.nomeArquivo") {
      return this.translate.currentLang == "br" ? "Arquivo" : "File Name";
    }
    if (item == "satisfacao.relatorioCargaGWM.tipoDescricao") {
      return this.translate.currentLang == "br" ? "Tipo" : "Type";
    }
    if (item == "satisfacao.relatorioCargaGWM.dtFimProc") {
      return this.translate.currentLang == "br" ? "Data Inc." : "Date Inc.";
    }
    if (item == "satisfacao.relatorioCargaGWM.dtProc") {
      return this.translate.currentLang == "br" ? "Data Proc." : "Date Proc.";
    }
    if (item == "satisfacao.relatorioCargaGWM.processado") {
      return "Status";
    }
  }

  private translateField(item) {    
    if (item === true) {
      return this.translate.currentLang === "br" ? "Processado" : "Processed";
    } else if (item === false) {
      return this.translate.currentLang === "br" ? "Pendente" : "Pending";
    }
    return item;
  }

  public exportExcel() {
    let registros = [];

    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value,
      this.f.nomeArquivo.value, this.f.tipoDescricao.value, this.f.processado.value).subscribe(dados => {
        registros = dados.dealers;
        this.orderByDate();

        registros.forEach(dados => {
          const atual = this.conversaoLibraConverte.conversaoLibra(dados.valorVenda, null, null);
          const valorFormatado = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(atual);
          // dados.valorVenda = valorFormatado.replace("R$", "");
          // dados.dataAbertura = dados.dataAbertura.substring(0, 10);
          // dados.dataFechamento = dados.dataFechamento.substring(0, 10);
        });

        if (registros.length > 0) {
          this.exportExcelService.nomeModulo = this.nomeModulo;
          this.exportExcelService.formatType = "0.00";
          // this.exportExcelService.colunasFormatacao = [0];
          // this.exportExcelService.colunasFormatacao = [6];
          this.exportExcelService.ExportTOExcelJSON(registros.map(r => {
            let linha = {};

            this._selectedColumns.forEach(c => {
              linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
            });

            return linha;
          }));
        }
      });
  }

  private changeLanguageValue() {
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.getAll();
      });
  }

}
